<h1 mat-dialog-title class="dialog-header">{{ data.title }}</h1>
<button mat-icon-button mat-dialog-close class="close-icon-button" (click)="onCancel()">
  <mic-icon class="close-icon" icon="close"></mic-icon>
</button>
<div mat-dialog-content class="dialog-content">
  @if (data.messageHtml) {
  <div [innerHTML]="data.messageHtml"></div>
  } @else {
  <p>{{ data.message }}</p>
  }
</div>
<div mat-dialog-actions class="dialog-action">
  <div style="display: flex; gap: 10px; width: 100%; justify-content: center">
    <button mat-stroked-button color="warn" style="width: 40%; font-size: 16px" (click)="onCancel()">
      {{ data.cancelButtonText || 'Cancel' }}
    </button>
    <button mat-flat-button color="primary" style="width: 40%; font-size: 16px" (click)="onSubmit()">
      {{ data.buttonText }}
    </button>
  </div>
</div>
